import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Auth } from 'aws-amplify';

import TopBar from 'layouts/Common/TopBar';
import { getUserInfo } from 'services/dynamicore/processes';
import { STEP } from 'views/Request/Common/constants';
import {
  getRequestsByClient,
  isAuthorizedRequest,
  isCompletedRequest,
  isPendingRequest,
  resolveActiveRequest,
} from 'views/Request/Common/requestForms';

import useStyles from './styles';

const PENDING_ONLY_PATHS = new Set([
  STEP.SIMULATOR,
  STEP.SIMULATOR_RESULTS,
  STEP.LOCATION,
  STEP.CUSTOMER,
  STEP.DOCUMENTATION,
  STEP.DOCUMENTATION_SHAREHOLDER,
  STEP.FINISH,
  'identity',
  STEP.PROCESSING,
  STEP.RELATIONSHIPS,
  STEP.STAKEHOLDERS,
  STEP.MAJORITY_SHAREHOLDER,
  STEP.SAT_CONNECTION,
  STEP.CREDIT_BUREAU_AUTH,
  STEP.CREDIT_BUREAU_OTP,
  STEP.PRE_PROPOSAL,
  STEP.PROPIETARIO_REAL_PLD,
  STEP.CREDIT_HISTORY_CHECK,
  'credit_history_check_autorization',
]);

const getRequestPathStep = (pathname = '') => pathname.replace(/^\/request\/?/, '').split('/')[0];

function RequestLayout({ children }) {
  const classes = useStyles();
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    const validateCompletedRequest = async () => {
      if (pathname === '/request' || pathname === '/request/requests') {
        return;
      }

      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        return;
      }

      try {
        const userInfo = await getUserInfo();
        const requests = await getRequestsByClient(userInfo?.entities?.peopleId);
        const activeRequest = resolveActiveRequest(requests);
        const pathStep = getRequestPathStep(pathname);

        if (
          PENDING_ONLY_PATHS.has(pathStep) &&
          activeRequest &&
          !isPendingRequest(activeRequest)
        ) {
          history.replace('/request/requests');
          return;
        }

        if (isCompletedRequest(activeRequest) || isAuthorizedRequest(activeRequest)) {
          history.replace('/request/requests');
        }
      } catch (error) {
        console.debug('[RequestLayout] Request guard error', error?.message || error);
      }
    };

    validateCompletedRequest();
  }, [history, pathname]);

  return (
    <div className={classes.root}>
      <TopBar
        isMenuCollapsible={false}
      />

      <div className={classes.wrapperCollapsed}>
        <div className={classes.contentContainer}>
          <div
            children={children}
            className={classes.content}
          />
        </div>
      </div>
    </div>
  );
}

RequestLayout.propTypes = {
  children: PropTypes.any,
};

export default RequestLayout;
